"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _router = _interopRequireDefault(require("../../_config/router"));
var _ = require("./");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Ne pas toucher, si une amélioration est à faire, prévenir dans le channel.
var _default = exports.default = {
  _get: key => {
    const path = _router.default[key];
    if (!path) {
      return false;
    }
    if (path.restrict) {
      if (!_._Security.isGranted(path.restrict)) {
        return false;
      }
    }
    return path.component;
  }
};